import { createReducerFromMap } from "@coverme/redux";
import { cloneDeep } from "lodash-es";

function isEmptyOrHasOnlyNulls(object, except = []) {
    if (Object.keys(object).length === 0 && object.constructor === Object) {
        return true;
    }

    for (const prop in object) {
        if (!object.hasOwnProperty(prop)) {
            continue;
        }

        if (except.indexOf(prop) > -1) {
            continue;
        }

        if (object[prop] != null) {
            return false;
        }
    }

    return true;
}

function areAllObjectsInArrayEmptyOrNull(sourceArray, except = []) {
    if (sourceArray == null) {
        return true;
    }

    if (sourceArray.length === 0) {
        return true;
    }

    for (const item of sourceArray) {
        if (!isEmptyOrHasOnlyNulls(item, except)) {
            return false;
        }
    }

    return true;
}

const initialState = {
    personal: {
        status: "none",
    },
    coverage: {
        status: "none",
    },
    summary: {
        status: "none",
    },
    continue: {
        status: "none",
    },
    supplemental: {
        status: "none",
    },
    secondary: {
        status: "none",
    },
    pi: {
        status: "none",
    },
    continue_pi_gate: {
        status: "none",
    },
    gov: {
        status: "none",
    },
    fa: {
        status: "none",
    },
    private: {
        status: "none",
    },
    matrix: {
        status: "none",
    },
    info: {
        status: "none",
    },
    household: {
        status: "none",
    },
    magi: {
        status: "none",
    },
    disclaimer: {
        status: "none",
    },
    documentation: {
        status: "none",
    },
};

function getStatus(section, status, state) {
    return {
        ...state,
        [section]: {
            status: status,
        },
    };
}

function updateStatus(section, status, state) {
    return {
        ...state,
        ...getStatus(section, status, state),
    };
}

function updateInterviewStatus(state, { section, status }) {
    return {
        ...state,
        [section]: {
            status: status,
        },
    };
}

function resetInterview() {
    return initialState;
}

function getInterview(state, action) {
    let newState = cloneDeep(state);
    function setStatusComplete(section) {
        return updateStatus(section, "complete", newState);
    }

    const { value } = action;

    newState = setStatusComplete("personal");

    if (value.coverage) {
        newState = setStatusComplete("coverage");
    }

    if (value.patientInfoScreening) {
        if (!isEmptyOrHasOnlyNulls(value.patientInfoScreening)) {
            newState = setStatusComplete("patientInfoScreening");
        }
    }

    if (value.householdMembers && value.householdMembers.length > 0) {
        newState = setStatusComplete("matrix");
    }

    if (
        value.personInfoScreenings &&
        value.personInfoScreenings.length > 0 &&
        areAllObjectsInArrayEmptyOrNull(value.personInfoScreenings, ["personId", "incomeInfo"]) === false
    ) {
        newState = setStatusComplete("matrix");
        newState = setStatusComplete("household");
    }

    if (value.government) {
        newState = setStatusComplete("gov");
    }

    if (value.financialAssistance) {
        newState = setStatusComplete("fa");
    }

    return newState;
}

export const uiStatusReducer = createReducerFromMap(initialState, {
    GET_INTERVIEW_COMPLETE: getInterview,
    UPDATE_ENTRY_START: updateStatus.bind(this, "personal", "loading"),
    UPDATE_ENTRY_COMPLETE: updateStatus.bind(this, "personal", "complete"),
    UPDATE_ENTRY_FAIL: updateStatus.bind(this, "personal", "error"),
    UPDATE_COVERAGE_START: updateStatus.bind(this, "coverage", "loading"),
    UPDATE_COVERAGE_COMPLETE: updateStatus.bind(this, "coverage", "complete"),
    UPDATE_COVERAGE_FAIL: updateStatus.bind(this, "coverage", "error"),
    UPDATE_PATIENT_INFO_SCREENING_START: updateStatus.bind(this, "info", "loading"),
    UPDATE_PATIENT_INFO_SCREENING_COMPLETE: updateStatus.bind(this, "info", "complete"),
    UPDATE_PATIENT_INFO_SCREENING_FAIL: updateStatus.bind(this, "info", "error"),
    UPDATE_HOUSEHOLD_MEMBERS_START: updateStatus.bind(this, "matrix", "loading"),
    UPDATE_HOUSEHOLD_MEMBERS_COMPLETE: updateStatus.bind(this, "matrix", "complete"),
    UPDATE_HOUSEHOLD_MEMBERS_FAIL: updateStatus.bind(this, "matrix", "error"),
    UPDATE_PERSONS_INFO_SCREENING_START: updateStatus.bind(this, "household", "loading"),
    UPDATE_PERSONS_INFO_SCREENING_COMPLETE: updateStatus.bind(this, "household", "complete"),
    UPDATE_PERSONS_INFO_SCREENING_FAIL: updateStatus.bind(this, "household", "error"),
    UPDATE_GOVERNMENT_START: updateStatus.bind(this, "gov", "loading"),
    UPDATE_GOVERNMENT_COMPLETE: updateStatus.bind(this, "gov", "complete"),
    UPDATE_GOVERNMENT_FAIL: updateStatus.bind(this, "gov", "error"),
    UPDATE_FINANCIAL_ASSISTANCE_START: updateStatus.bind(this, "fa", "loading"),
    UPDATE_FINANCIAL_ASSISTANCE_COMPLETE: updateStatus.bind(this, "fa", "complete"),
    UPDATE_FINANCIAL_ASSISTANCE_FAIL: updateStatus.bind(this, "fa", "error"),
    SET_PI_GATE_START: updateStatus.bind(this, "pi", "loading"),
    SET_PI_GATE_COMPLETE: updateStatus.bind(this, "pi", "complete"),
    SET_PI_GATE_FAIL: updateStatus.bind(this, "pi", "error"),
    UPDATE_INTERVIEW_STATUS: updateInterviewStatus,
    RESET_INTERVIEW: resetInterview,
});
